import type {
  AddWinnersBody,
  AddWinnersParams,
  AddWinnersResponse,
  GetWinnersParams,
  GetWinnersResponse,
  InvalidateWinnersBody,
  InvalidateWinnersParams,
  InvalidateWinnersResponse,
  ReplaceWinnersBody,
  ReplaceWinnersParams,
  ReplaceWinnersResponse,
} from '@lotta/shared/types-lottery-api';
import { apis } from './apis';

const winnerApis = apis.injectEndpoints({
  endpoints: (build) => ({
    getWinners: build.query<GetWinnersResponse, GetWinnersParams>({
      query: ({ retailUnit, lotteryId, lotteryDrawId }) =>
        `/${retailUnit}/lottery/${lotteryId}/draw/${lotteryDrawId}/winner`,
    }),
    addWinners: build.mutation<AddWinnersResponse, AddWinnersParams & AddWinnersBody>({
      query: ({ retailUnit, lotteryId, lotteryDrawId, numberOfNewWinners }) => ({
        url: `/${retailUnit}/lottery/${lotteryId}/draw/${lotteryDrawId}/winner`,
        method: 'POST',
        body: { numberOfNewWinners },
      }),
    }),
    invalidateWinners: build.mutation<
      InvalidateWinnersResponse,
      InvalidateWinnersParams & InvalidateWinnersBody
    >({
      query: ({ retailUnit, lotteryId, lotteryDrawId, winners }) => ({
        url: `/${retailUnit}/lottery/${lotteryId}/draw/${lotteryDrawId}/winner/invalidate`,
        method: 'POST',
        body: { winners },
      }),
    }),
    replaceWinners: build.mutation<
      ReplaceWinnersResponse,
      ReplaceWinnersParams & ReplaceWinnersBody
    >({
      query: ({ retailUnit, lotteryId, lotteryDrawId, winners }) => ({
        url: `/${retailUnit}/lottery/${lotteryId}/draw/${lotteryDrawId}/winner/replace`,
        method: 'POST',
        body: { winners },
      }),
    }),
  }),
});

export const {
  useGetWinnersQuery,
  useAddWinnersMutation,
  useInvalidateWinnersMutation,
  useReplaceWinnersMutation,
} = winnerApis;
